import React from 'react';
import fadeInAndOut from 'src/components/animations/SkeletonFadeInAndOut';
import styled, { css } from 'styled-components';

type Props = {
  isMobile?: boolean;
};

const EmptyFilterItem = ({ isMobile }: Props) => (
  <EmptyFilterItemContainer $isMobile={isMobile}>
    <EmptyFilterCheckbox $isMobile={isMobile} />
    <EmptyFilterLabel $isMobile={isMobile} />
  </EmptyFilterItemContainer>
);
const EmptyFilter = ({ isMobile }: Props) => (
  <EmptyFilterContainer $isMobile={isMobile}>
    <EmptyFilterHeader $isMobile={isMobile} />
    {Array(3)
      .fill(null)
      .map((unused, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <EmptyFilterItem key={idx} isMobile={isMobile} />
      ))}
  </EmptyFilterContainer>
);

const FiltersSkeleton = ({ isMobile }: Props) => (
  <div className="filters">
    {Array(7)
      .fill(null)
      .map((_unused, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <EmptyFilter key={idx} isMobile={isMobile} />
      ))}
  </div>
);

const EmptyFilterContainer = styled.div<{ $isMobile?: boolean }>`
  ${(props) =>
    props.$isMobile
      ? css`
          &:first-of-type {
            margin-top: 18px;
          }
          padding-left: 10px;
          padding-right: 10px;
        `
      : css`
          display: flex;
          flex-direction: column;
          margin-bottom: 15px;
        `}
`;

const EmptyFilterHeader = styled.div<{ $isMobile?: boolean }>`
  width: 50%;
  height: 18px;
  background-color: rgba(223, 223, 223, 0.8);
  margin-bottom: 10px;
  border-radius: 5px;
`;

const EmptyFilterItemContainer = styled.div<{ $isMobile?: boolean }>`
  ${(props) =>
    props.$isMobile
      ? css`
          display: flex;
          flex-direction: row-reverse;
          align-items: center;
        `
      : css`
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-bottom: 5px;
        `}

  margin-bottom: 5px;
  opacity: 1;
  animation: ${fadeInAndOut} 1.2s ease-in-out infinite;
`;

const EmptyFilterLabel = styled.div<{ $isMobile?: boolean }>`
  margin-left: 7px;
  width: 70%;
  height: 1px;
  background-color: #c2c5cc;
  border-radius: 4px;

  ${(props) =>
    props.$isMobile &&
    css`
      margin-left: 0;
      margin-right: 47px;
      width: calc(100% - 47px);
    `}
`;

const EmptyFilterCheckbox = styled.span<{ $isMobile?: boolean }>`
  margin: 0;
  position: relative;
  display: inline-block;

  border: solid 1px #4c4c4c;

  pointer-events: none;
  border-color: #c2c5cc;

  border-radius: 2px;
  box-shadow: none;

  ${(props) =>
    props.$isMobile
      ? css`
          min-width: 24px;
          height: 24px;
          border-style: dotted;
        `
      : css`
          min-width: 14px;
          height: 14px;
        `}
`;

export default FiltersSkeleton;
